<template>
	<div id="base" style="background: #fff">
		<div class="">
			<div class="toptitle" v-if="ok">
				<div class="">
					<img src="/static/qmsj/img/time.png" style="vertical-align: middle"><span class="title1">{{hdname}}<span class="kind">（{{hdtype}}）</span></span>
				</div>
				<div class="">
					<el-input class="text" size="mini" placeholder="请输入姓名、电话搜索" v-model="search.name" @keyup.enter.native="searchname">
						<div slot="append" class="el-icon-search" v-on:click="searchname"></div>
					</el-input>
				</div>
			</div>
			<div class="top_b" style="padding: 0 10px">
				<el-row>
					<el-col :span="12">
						<div class="look">
							总订单量：
							<span style="color:rgb(124,114,193);font-size: 28px;
                            margin: 0 10px;">{{order_num}}</span></div>
					</el-col>
					<el-col :span="12">

						<div class="look">
							商品兑换数量：
							<span style="color:rgb(124,114,193);font-size: 28px;
                            margin: 0 10px;">{{goods_num}}</span></div>
					</el-col>


					<!--<div class="count">-->
					<!--<ul>-->
					<!--<li style="color:rgb(153,153,153)"><span class="li_span"></span><span class="lisum">商品兑换数量</span><div class="li_count">{{goods_num}}</div></li>-->

					<!--</ul>-->
					<!--</div>-->
					</el-col>
				</el-row>
			</div>


			<div class="t_text">

			</div>
		</div>
		<!-- 列表 -->
		<div class="background">
			<div class="tab">
				<table class="table table-bordered">
					<thead>
						<tr>
							<th>序号</th>
							<th>姓名</th>
							<th>电话</th>
							<th>商品兑换</th>
							<th>状态</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) in tableData.data" :key="index">
							<td>{{index+1}}</td>
							<td>{{item.jz_name}}</td>
							<td>{{item.phone}}</td>
							<td>{{item.gift}}</td>
							<td>{{item.use}}</td>

						</tr>
					</tbody>

				</table>
			</div>
			<div class="foot">
				<p><span class="foot_span">共{{tableData.total}}条记录</span>当前{{tableData.page}}页/共{{tableData.totalpage}}页</p>

				<!-- 分页 -->
				<el-pagination class="f_page" background @current-change="handleCurrentChange" :current-page="tableData.page"
				 layout="prev, pager, next" :total="tableData.total">
				</el-pagination>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				ok: true,
				order_num: 0,
				goods_num: 0,
				count2: 0,
				count3: 0,
				count4: 0,
				count5: 0,
				hdname: "活动名称",
				hdtype: "活动类型",

				search: {
					name: ""
				},
				tableData: {
					data: [],
					page: 1,
					total: 0,
					totalpage: 10,
				},
				token: ''
			}
		},
		filters: {
			typename: function(value) {
				if (value == 1) return "专家测评"
				if (value == 2) return "家长测评"
			}
		},
		methods: {
			handleCurrentChange(val) {
				//            console.log(`当前页: ${val}`);
				this.tableData.page = val;
				this.loaddata();
			},
			loaddata() {
				var arr = this;
				var id = this.$route.query.Id;
				$.ajax({
					url: process.env.apiUrl + "saas/group/show_details",
					type: "post",
					data: {
						token: this.token,
						hdid: id,
						search: this.search.name,
						page: this.tableData.page
					},
					success: function(response) {
						//                    console.log(response)
						if (response.map.order_num == 0) {
							arr.tableData.data = [];
							arr.tableData.total = 0;
							arr.tableData.totalpage = 1;
							arr.order_num = 0;
							arr.goods_num = 0;
							// arr.ok=false;
						} else {
							arr.tableData.data = response.data;
							arr.tableData.totalpage = response.map.pagetotal;
							arr.order_num = response.map.order_num;
							arr.goods_num = response.map.goods_num;
							arr.tableData.total = response.map.order_num;
						}
						arr.hdname = response.map.hdname;
						arr.hdtype = response.map.hdtype;
					},
					// error:function(e){
					//     alert("错误！！");
					//     window.clearInterval(timer);
					// }
				});
			},
			searchname() {
				this.tableData.page = 1;
				this.loaddata();
			}

		},
		mounted: function() {
			this.token = $.cookie('token');
			this.loaddata();

		}

	}
</script>


<style>
	* {
		padding: 0;
		margin: 0;
	}

	.toptitle {
		box-sizing: border-box;
		padding: 0 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		min-height: 50px;
	}

	.toptitle img {
		width: 30px;
	}

	#base {
		display: flex;
		flex-flow: column;
		/* padding: 10px; */
		width: 100%;
		height: 100%;
		background: #fff;

	}

	.background {
		background-color: #ffffff;
		margin: 10px;
	}

	.look {
		display: flex;
		width: 100%;
		justify-content: flex-start;
		align-items: center;
		box-sizing: border-box;
		padding-left: 50px;
	}


	.tab {
		width: 100%;
		height: auto;
	}

	.text {
		width: 200px;
		height: 25px;
		border: 2px solid rgb(124, 114, 193);
		border-radius: 20px;
		/* box-shadow: 0 5px 5px 5px rgb(226,226,228); */
		/* text-align: center; */
		background: white;
	}

	.count {
		padding-top: 10px;
	}

	.count ul {
		width: 100%;
		height: 80px;
	}

	.count li {
		display: inline-block;
		/* margin: 10px; */
		width: 19%;
		height: 70px;
		border-left: 1px solid rgb(153, 153, 153);
		text-align: center;
		/* line-height: 80px; */
	}

	.li_span {
		display: inline-block;
		width: 10px;
		height: 10px;
		border: 1px solid rgb(153, 153, 153);
		background: rgb(153, 153, 153);
		border-radius: 50%;
		margin: 0 5px;
	}

	.top .li_count {
		color: #7B7B7B;
		font-weight: bold;
		font-size: 20px;
	}

	.top .lisum {
		font-size: 14px;
	}

	/* .li_count{
        position: relative;
        left: 40px;
    } */
	/* table样式 */
	table.gridtable {
		width: 100%;
		/* margin-top: 10px; */
		font-family: verdana, arial, sans-serif;
		/* font-size:11px; */
		color: #333333;
		border-width: 1px;
		border-color: #666666;
		border-collapse: collapse;
	}

	table.gridtable th {
		font-size: 16px;
		height: 40px;
		color: rgb(102, 102, 102);
		border-width: 0px;
		padding: 8px;
		border-style: solid;
		/* border-color: #666666; */
		background-color: #f1f1f1;
		/* box-shadow: 0 5px 0 0 red; */
	}

	table.gridtable td {
		font-weight: bold;
		font-size: 12px;
		height: 20px;
		color: rgb(153, 153, 153);
		text-align: center;
		border-width: 0px;
		padding: 8px;
		border-style: solid;
		/* border-color: #666666; */
		background-color: #ffffff;
	}

	.td_btn {
		font-weight: bold;
		width: 70px;
		height: 25px;
		background-color: #f1f1f1;
		color: rgb(124, 114, 193);
		border: 0;
		margin: 0 10px;
		border-radius: 20px;
		font-size: 12px;
	}

	.foot {
		padding-left: 25px;

	}

	.foot p {
		font-size: 12px;
		height: 20px;
		color: rgb(153, 153, 153);
		width: 100%;
		padding: 30px 0;
	}

	.foot .f_page {
		text-align: center;
	}

	.foot_span {
		margin-right: 5px;
	}

	#base .el-input__inner {
		border-radius: 20px;
		padding: 0 5px 0 15px;
		border: 0;
	}

	#base .el-input-group__append {
		border: 0;
		background: white;
		border-radius: 20px;
		color: rgb(124, 114, 193);
		/*font-size: 18px;*/
		padding: 0 20px 0 0;
	}

	#base .el-input-group__append:hover {
		cursor: pointer;
	}

	#base .el-input__inner::placeholder {
		color: rgb(153, 153, 153);
	}

	#base .color_a {
		color: rgb(153, 153, 153);
		font-size: 12px;
		height: 20px;
		text-decoration: none;
	}

	#base .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: rgb(124, 114, 193);
		color: white;
	}

	#base .el-pagination.is-background .btn-next,
	#base .el-pagination.is-background .btn-prev,
	#base .el-pagination.is-background .el-pager li {
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ceping/actxiang.vue